import { render, staticRenderFns } from "./UserManagmentItem.vue?vue&type=template&id=5dff929b&scoped=true"
import script from "./UserManagmentItem.vue?vue&type=script&lang=js"
export * from "./UserManagmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff929b",
  null
  
)

export default component.exports